
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const service = namespace("service");
const setting = namespace("setting");
const app = namespace("app");
@Component({})
export default class Resettle extends Vue {
  @Prop({ type: Boolean, default: false })
  confirmBtnLoading;
  @setting.Action getPatternPaymentList;
  @service.Action getOrderDetail;
  @service.Action returnOrder;
  @service.Action queryReturnOrderParts;
  @service.Action queryReturnDiscount;
  @service.Action queryReturnOrderStaffCommission;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  detailData: any = {};
  payWayList: any[] = [];
  formData: any = {
    orderNo: "",
    paymentAmount: "",
    paymentMethod: "",
    remark: ""
  };
  formDataRules: any = {
    remark: { required: true, message: t("v210831.please-enter-refund"), trigger: "blur" },
    paymentMethod: { required: true, message: t("v3_2_1.please-refund-payway"), trigger: "change" }
  };
  partsTableData: any = [];
  staffTableData: any = [];
  isLoad: boolean = false;
  stepList: any = [];
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.formData.orderNo = this.orderId;
    this.init();
  }
  returnDiscountData: any = {};
  get returnDiscountList() {
    return (this.returnDiscountData?.itemList || []).map(item => {
      if (item.discountExpirationTime) {
        item.discountExpirationTimeShow = dayjs(item.discountExpirationTime).format("YYYY-MM-DD HH:mm:ss");
        item.isExpired = dayjs().isAfter(dayjs(item.discountExpirationTime));
      } else {
        item.discountExpirationTimeShow = "-";
        item.isExpired = false;
      }

      return item;
    });
  }
  onlyStoredValuePaid = false;
  async init() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    let payListData = await this.getPatternPaymentList({
      status: "1"
    });
    this.payWayList = (payListData?.data || []).filter(item => {
      return item.payMethodCode !== "6";
    });
    let detailData = await this.getOrderDetail({
      orderNo: this.orderId
    });
    this.detailData = detailData.data;
    if (this.detailData.settlementStatus === "1") {
      if (this.detailData?.paymentList?.length) {
        const firstPaidMethod = this.detailData.paymentList?.[0]?.paidMethod || "";
        const firstPayMethod = this.payWayList?.[0]?.payMethodCode || "";
        this.formData.paymentMethod = firstPaidMethod === "6" ? firstPayMethod : firstPaidMethod;
        if (this.detailData.paymentList.length === 1 && firstPaidMethod === "6") {
          this.onlyStoredValuePaid = true;
          this.formData.paymentMethod = "";
        }
      } else {
        // 退款金额为0
        this.formData.paymentMethod = this.payWayList[0].payMethodCode;
      }
    }

    let partsData = await this.queryReturnOrderParts({
      orderNo: this.orderId
    });
    this.partsTableData = partsData.data;

    let staffData = await this.queryReturnOrderStaffCommission({
      orderNo: this.orderId
    });
    this.staffTableData = staffData.data;
    let returnDiscountData = await this.queryReturnDiscount({
      orderNo: this.orderId
    });
    this.returnDiscountData = returnDiscountData.data;

    const onAcountDiscount = this.detailData?.onAccount?.discountAmount || 0;
    this.formData.paymentAmount = (
      Number(this.detailData.orderAmount) -
      Number(this.returnDiscountData.sumDiscount) -
      Number(onAcountDiscount)
    ).toFixed(2);
    if (this.detailData.settlementStatus === "1") {
      this.stepList.push({
        name: t("v210831.refund"),
        info: t("v210831.the-chargeback-settlement-tips1")
      });
    }
    if (this.partsTableData.length) {
      this.stepList.push({
        name: t("v210831.return-stock-in"),
        info: t("v210831.the-return-settlement")
      });
    }
    if (this.staffTableData.length) {
      this.stepList.push({
        name: t("v210831.deduction-of-commission"),
        info: t("v210831.the-chargeback-settlement-tips2")
      });
    }
    loading.close();
    this.isLoad = true;
  }
  handleClose() {
    if (this.$listeners.cancel) {
      this.$emit("cancel");
    } else {
      this.$emit("update:visible", false);
    }
  }

  async confirm() {
    if (this.stepList.length && this.$refs.contentForm) {
      await (this.$refs.contentForm as any).validate();
    }
    this.btnStartLoading();
    this.returnOrder({ ...this.formData })
      .then(() => {
        this.$emit("confirm");
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleLinkReceipt(orderData) {
    let { href } = this.$router.resolve({
      path: `/finance/collection-order-view/${orderData.receiptNo}`
    });
    window.open(href, "_blank");
  }
}
